/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Activation_Machine_Id_LabelInputs */

const en_offline_activation_machine_id_label = /** @type {(inputs: Offline_Activation_Machine_Id_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Machine Id`)
};

const fr_offline_activation_machine_id_label = /** @type {(inputs: Offline_Activation_Machine_Id_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identifiant machine`)
};

const de_offline_activation_machine_id_label = /** @type {(inputs: Offline_Activation_Machine_Id_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maschinen-ID`)
};

const it_offline_activation_machine_id_label = /** @type {(inputs: Offline_Activation_Machine_Id_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID macchina`)
};

const ru_offline_activation_machine_id_label = /** @type {(inputs: Offline_Activation_Machine_Id_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Идентификатор машины`)
};

const es_offline_activation_machine_id_label = /** @type {(inputs: Offline_Activation_Machine_Id_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identificación de la máquina`)
};

const zh_cn2_offline_activation_machine_id_label = /** @type {(inputs: Offline_Activation_Machine_Id_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`机器 ID`)
};

const ja_offline_activation_machine_id_label = /** @type {(inputs: Offline_Activation_Machine_Id_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マシンID`)
};

const hi_offline_activation_machine_id_label = /** @type {(inputs: Offline_Activation_Machine_Id_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मशीन आईडी`)
};

const pt_pt2_offline_activation_machine_id_label = /** @type {(inputs: Offline_Activation_Machine_Id_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID da máquina`)
};

/**
* | output |
* | --- |
* | "Machine Id" |
*
* @param {Offline_Activation_Machine_Id_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_activation_machine_id_label = /** @type {((inputs?: Offline_Activation_Machine_Id_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Activation_Machine_Id_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_offline_activation_machine_id_label(inputs)
	if (locale === "de") return de_offline_activation_machine_id_label(inputs)
	if (locale === "it") return it_offline_activation_machine_id_label(inputs)
	if (locale === "ru") return ru_offline_activation_machine_id_label(inputs)
	if (locale === "es") return es_offline_activation_machine_id_label(inputs)
	if (locale === "zh-CN") return zh_cn2_offline_activation_machine_id_label(inputs)
	if (locale === "ja") return ja_offline_activation_machine_id_label(inputs)
	if (locale === "hi") return hi_offline_activation_machine_id_label(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_activation_machine_id_label(inputs)
	return en_offline_activation_machine_id_label(inputs)
});